<template>
  <div class="layer-tem">
    <!-- 关闭按钮 -->
    <img :src="newClose" class="close-btn" alt="" @click="closeLayer">
    <!-- 下拉框 -->
    <div class="table-tit dp_fs_color">
      {{ tableTit }}
    </div>
    <div class="select-wrap">
      <!-- 标题 -->
      <div>
        <div class="tit"
          v-if="tableTit == '电气火灾监控' || tableTit == '消防水系统' || tableTit == '独立式探测器' || tableTit == '自动灭火系统' || tableTit == '智能空开' || tableTit == '传输装置'">
          联网设备数
        </div>
      </div>
      <div>
        <Select v-model="areaId" transfer :word-wrap="true" clearable style="width: 100px;margin-right: 5px;"
          placeholder="全部区域" filterable @on-change="formChange">
          <Option v-for="item in areaArr" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <Select v-model="industId" transfer :word-wrap="true" clearable style="width: 100px;margin-right: 5px;"
          placeholder="全部行业" filterable @on-change="formChange">
          <Option v-for="item in industArr" :value="item.value" :key="item.id">{{ item.name }}</Option>
        </Select>
        <!-- <Select
                v-model="departId"
                transfer
                :word-wrap="true"
                clearable
                style="width: 100px;margin-right: 5px;"
                placeholder="全部单位"
                filterable
                @on-change="formChange"
            >
            <Option v-for="item in departArr" :value="item.id" :key="item.id">{{item.name}}</Option>
            </Select> -->
      </div>
    </div>
    <!-- 列表 滚动加载更多 -->
    <div class="table-wrap">
      <div class="table-head">
        <table>
          <tr v-if="tableTit == '消防主机'">
            <th width="10%">
              序号
            </th>
            <th width="25%">
              单位名称
            </th>
            <th width="10%">
              区域
            </th>
            <th width="10%">
              单位类别
            </th>
            <th width="10%">
              主机数量
            </th>
            <th width="25%">
              单位地址
            </th>
            <th width="10%">
              操作
            </th>
          </tr>
          <tr
            v-if="tableTit == '电气火灾监控' || tableTit == '消防水系统' || tableTit == '独立式探测器' || tableTit == '自动灭火系统' || tableTit == '智能空开' || tableTit == '传输装置'">
            <th width="10%">
              序号
            </th>
            <th width="20%">
              单位名称
            </th>
            <th width="10%">
              区域
            </th>
            <th width="20%">
              单位类别
            </th>
            <th width="15%">
              异常数
            </th>
            <th width="15%">
              正常数
            </th>
            <th width="10%">
              详情
            </th>
          </tr>
          <tr v-if="tableTit == '巡检系统(NFC)'">
            <th width="10%">
              序号
            </th>
            <th width="10%">
              单位名称
            </th>
            <th width="20%">
              区域
            </th>
            <th width="20%">
              单位类别
            </th>
            <th width="30%">
              安装数量
            </th>
            <th width="10%">
              操作
            </th>
          </tr>
          <tr v-if="tableTit == '视频监控'">
            <th width="10%">
              序号
            </th>
            <th width="15%">
              单位名称
            </th>
            <th width="15%">
              区域
            </th>
            <th width="15%">
              单位类别
            </th>
            <th width="10%">
              异常数
            </th>
            <th width="10%">
              正常数
            </th>
            <th width="15%">
              安装数量
            </th>
            <th width="10%">
              操作
            </th>
          </tr>
        </table>
      </div>
      <div class="table-body" id="rightBot">
        <table v-if="tableTit == '消防主机'">
          <tr v-for="(item, index) in tableList" :key="index">
            <td width="10%">
              {{ index + 1 }}
            </td>
            <td width="25%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.orgName" v-if="item.orgName">
                {{ item.orgName }}
              </Poptip>
            </td>
            <td width="10%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.areaName" v-if="item.areaName">
                {{ item.areaName }}
              </Poptip>
            </td>
            <td width="10%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.industryCategoryName"
                v-if="item.industryCategoryName">
                {{ item.industryCategoryName }}
              </Poptip>
            </td>
            <td width="10%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.count">
                {{ item.count }}
              </Poptip>
            </td>
            <td width="25%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.address" v-if="item.address">
                {{ item.address }}
              </Poptip>
            </td>
            <td width="10%">
              <span class="viewDetail" @click="tdGetZjData(item.orgId, item.orgName)">查看</span>
            </td>
          </tr>
        </table>
        <table
          v-if="tableTit == '电气火灾监控' || tableTit == '消防水系统' || tableTit == '独立式探测器' || tableTit == '自动灭火系统' || tableTit == '智能空开' || tableTit == '传输装置'">
          <tr v-for="(item, index) in tableList" :key="index">
            <td width="10%">
              {{ index + 1 }}
            </td>
            <td width="20%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.orgName" v-if="item.orgName">
                {{ item.orgName }}
              </Poptip>
            </td>
            <td width="10%">
              <Poptip v-if="item.areaName" trigger="hover" transfer :word-wrap="true" :content="item.areaName">
                {{ item.areaName }}
              </Poptip>
            </td>
            <td width="20%">
              <Poptip
                v-if="item.industryCategoryName"
                trigger="hover"
                transfer
                :word-wrap="true"
                :content="item.industryCategoryName"
              >
                {{item.industryCategoryName}}
              </Poptip>
            </td>
            <td width="15%">
              <Poptip
                trigger="hover"
                transfer
                :word-wrap="true"
                :content="item.offLine"
              >
                {{item.offLine}}
              </Poptip>
            </td>
            <td width="15%">
              <Poptip
                trigger="hover"
                transfer
                :word-wrap="true"
                :content="item.onLine"
              >
                {{item.onLine}}
              </Poptip>
            </td>
            <td width="10%">
              <span
                class="viewDetail"
                @click="tdGetZjData(item.orgId, item.orgName)"
              >查看</span>
            </td>
          </tr>
        </table>
        <table v-if="tableTit=='巡检系统(NFC)'">
          <tr
            v-for="(item, index) in tableList"
            :key="index"
          >
            <td width="10%">
              {{index+1}}
            </td>
            <td width="10%">
              <Poptip
                trigger="hover"
                transfer
                :word-wrap="true"
                :content="item.orgName"
                v-if="item.orgName"
              >
                {{item.orgName}}
              </Poptip>
            </td>
            <td width="20%">
              <Poptip
                v-if="item.areaName"
                trigger="hover"
                transfer
                :word-wrap="true"
                :content="item.areaName"
              >
                {{item.areaName}}
              </Poptip>
            </td>
            <td width="20%">
              <Poptip
                v-if="item.industryCategoryName"
                trigger="hover"
                transfer
                :word-wrap="true"
                :content="item.industryCategoryName"
              >
                {{item.industryCategoryName}}
              </Poptip>
            </td>
            <td width="30%">
              <Poptip
                trigger="hover"
                transfer
                :word-wrap="true"
                :content="item.count"
              >
                {{item.count}}
              </Poptip>
            </td>

            <td width="10%">
              <span
                class="viewDetail"
                @click="tdGetZjData(item.orgId, item.orgName)"
              >查看</span>
            </td>
          </tr>
        </table>
        <table v-if="tableTit=='视频监控'">
          <tr
            v-for="(item, index) in tableList"
            :key="index"
          >
            <td width="10%">
              {{index+1}}
            </td>
            <td width="15%">
              <Poptip
                trigger="hover"
                transfer
                :word-wrap="true"
                :content="item.orgName"
                v-if="item.orgName"
              >
                {{item.orgName}}
              </Poptip>
            </td>
            <td width="15%">
              <Poptip
                trigger="hover"
                transfer
                :word-wrap="true"
                :content="item.areaName"
                v-if="item.areaName"
              >
                {{item.areaName}}
              </Poptip>
            </td>
            <td width="15%">
              <Poptip
                trigger="hover"
                transfer
                :word-wrap="true"
                :content="item.industryCategoryName"
                v-if="item.industryCategoryName"
              >
                {{item.industryCategoryName}}
              </Poptip>
            </td>
            <td width="10%">
              <Poptip
                trigger="hover"
                transfer
                :word-wrap="true"
                :content="item.offLine"
              >
                {{item.offLine}}
              </Poptip>
            </td>
            <td width="10%">
              <Poptip
                trigger="hover"
                transfer
                :word-wrap="true"
                :content="item.onLine"
              >
                {{item.onLine}}
              </Poptip>
            </td>
            <td width="15%">
              <Poptip
                trigger="hover"
                transfer
                :word-wrap="true"
                :content="item.count"
              >
                {{item.count}}
              </Poptip>
            </td>
            <td width="10%">
              <span
                class="viewDetail"
                @click="tdGetZjData(item.orgId, item.orgName)"
              >查看</span>
            </td>
          </tr>
        </table>
        <p
          class="no-data"
          v-show="!tableList.length && getTableStatus"
        >
          暂无数据
        </p>
      </div>
    </div>
    <!-- 标题 -->
    <div class="select-wrap">
      <div class="tit zj-tit">
        {{zjTit}}
      </div>
      <div>
      <Select
          v-model="partTypeCode"
          transfer
          :word-wrap="true"
          clearable
          style="width: 150px;margin-right: 5px;"
          placeholder="设施系统形式" v-if="tableTit=='独立式探测器'"
          @on-change="formChange"
        >
        <Option
          v-for="item in partTypeArr"
          :value="item.value"
          :key="item.id"
        >
          {{ item.name }}
        </Option>
      </Select>
      <Select
        v-model="deviceStatus"
        transfer
        :word-wrap="true"
        clearable
        style="width: 100px;margin-right: 5px;"
        placeholder="部件状态"
        @on-change="formChange1"
        v-if="tableTit=='电气火灾监控' || tableTit=='消防水系统' || tableTit=='独立式探测器'||tableTit=='自动灭火系统' || tableTit=='智能空开'|| tableTit=='传输装置'"
      >
        <Option
          v-for="item in deviceStatusArr"
          :value="item.value"
          :key="item.id"
        >
          {{ item.name }}
        </Option>
      </Select>
      </div>
    </div>

    <div class="table-wrap">
      <div class="table-head">
        <table>
          <tr v-if="tableTit == '消防主机'">
            <th width="10%">
              序号
            </th>
            <th width="20%">
              单位名称
            </th>
            <th width="20%">
              主机名称
            </th>
            <th width="20%">
              品牌
            </th>
            <th width="20%">
              型号
            </th>
            <th width="10%">
              通讯模组
            </th>
          </tr>
          <tr
            v-if="tableTit == '电气火灾监控' || tableTit == '消防水系统' || tableTit == '独立式探测器' || tableTit == '自动灭火系统' || tableTit == '智能空开'">
            <th width="5%">
              序号
            </th>
            <th width="10%">
              单位名称
            </th>
            <th width="10%">
              设施名称
            </th>
            <th width="10%">
              设施系统类型
            </th>
            <th width="15%">
              所属建筑
            </th>
            <th width="10%">
              所属楼层
            </th>
            <th width="15%">
              安装位置
            </th>
            <th width="10%">
              部件状态
            </th>
            <th width="5%">
              详情
            </th>
          </tr>
          <tr v-if="tableTit == '巡检系统(NFC)'">
            <th width="10%">
              序号
            </th>
            <th width="10%">
              单位名称
            </th>
            <th width="20%">
              卡印序号
            </th>
            <th width="20%">
              设备/重点部位名称
            </th>
            <th width="30%">
              安装位置
            </th>
            <th width="10%">
              操作
            </th>
          </tr>
          <tr v-if="tableTit == '传输装置'">
            <th width="10%">
              序号
            </th>
            <th width="10%">
              单位名称
            </th>
            <th width="15%">
              传输装置类型
            </th>
            <th width="15%">
              传输装置型号
            </th>
            <th width="30%">
              传输装置唯一号
            </th>
            <th width="10%">
              传输装置状态
            </th>
            <th width="10%">
              详情
            </th>
          </tr>
          <tr v-if="tableTit == '视频监控'">
            <th width="10%">
              序号
            </th>
            <th width="15%">
              单位名称
            </th>
            <th width="15%">
              摄像头名称
            </th>
            <th width="15%">
              设备/重点部位名称
            </th>
            <!-- <th width="15%">
              安装位置
            </th> -->
            <th width="15%">
              部件状态
            </th>
            <th width="15%">
              操作
            </th>
          </tr>
        </table>
      </div>
      <div class="table-body" id="rightBot_zj">
        <table v-if="tableTit == '消防主机'">
          <tr v-for="(item, index) in zjTableArr" :key="index">
            <td width="10%">
              {{ index + 1 }}
            </td>
            <td width="20%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.orgName" v-if="item.orgName">
                {{ item.orgName }}
              </Poptip>
            </td>
            <td width="20%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.name" v-if="item.name">
                {{ item.name }}
              </Poptip>
            </td>
            <td width="20%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.manufacturerName"
                v-if="item.manufacturerName">
                {{ item.manufacturerName }}
              </Poptip>
            </td>
            <td width="20%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.model" v-if="item.model">
                {{ item.model }}
              </Poptip>
            </td>
            <td width="10%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.moduleName" v-if="item.moduleName">
                {{ item.moduleName }}
              </Poptip>
            </td>
          </tr>
        </table>
        <table
          v-if="tableTit == '电气火灾监控' || tableTit == '消防水系统' || tableTit == '独立式探测器' || tableTit == '自动灭火系统' || tableTit == '智能空开'">
          <tr v-for="(item, index) in zjTableArr" :key="index">
            <td width="5%">
              {{ index + 1 }}
            </td>
            <td width="10%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.orgName" v-if="item.orgName">
                {{ item.orgName }}
              </Poptip>
            </td>
            <td width="10%">
              <Poptip v-if="item.deviceName" trigger="hover" transfer :word-wrap="true" :content="item.deviceName">
                {{ item.deviceName }}
              </Poptip>
            </td>
            <td width="15%">
              <Poptip v-if="item.typeName" trigger="hover" transfer :word-wrap="true" :content="item.typeName">
                {{ item.typeName }}
              </Poptip>
            </td>
            <td width="15%">
              <Poptip v-if="item.buildingName" trigger="hover" transfer :word-wrap="true" :content="item.buildingName">
                {{ item.buildingName }}
              </Poptip>
            </td>
            <td width="15%">
              <Poptip v-if="item.floor" trigger="hover" transfer :word-wrap="true" :content="item.floor">
                {{ item.floor }}
              </Poptip>
            </td>
            <td width="10%">
              <Poptip v-if="item.position && item.position != 'null'" trigger="hover" transfer :word-wrap="true"
                :content="item.position">
                {{ item.position }}
              </Poptip>
            </td>
            <td width="10%">
              <Poptip v-if="item.stateName" trigger="hover" transfer :word-wrap="true" :content="item.stateName">
                {{ item.stateName }}
              </Poptip>
            </td>
            <td width="10%">
              <span class="viewDetail" @click="showDetailLayer(item.orgId, item.orgName)">查看</span>
            </td>
          </tr>
        </table>
        <table v-if="tableTit == '巡检系统(NFC)'">
          <tr v-for="(item, index) in zjTableArr" :key="index">
            <td width="10%">
              {{ index + 1 }}
            </td>
            <td width="10%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.orgName" v-if="item.orgName">
                {{ item.orgName }}
              </Poptip>
            </td>
            <td width="20%">
              <Poptip v-if="item.pressNum" trigger="hover" transfer :word-wrap="true" :content="item.pressNum">
                {{ item.pressNum }}
              </Poptip>
            </td>
            <td width="20%">
              <Poptip v-if="item.deviceName" trigger="hover" transfer :word-wrap="true" :content="item.deviceName">
                {{ item.deviceName }}
              </Poptip>
            </td>
            <td width="30%">
              <Poptip v-if="item.installPlace" trigger="hover" transfer :word-wrap="true" :content="item.installPlace">
                {{ item.installPlace }}
              </Poptip>
            </td>
            <td width="10%">
              <span class="viewDetail" @click="showDetailLayer(xjOrgId, item, item.orgName)">查看</span>
            </td>
          </tr>
        </table>

        <table v-if="tableTit == '视频监控'">
          <tr v-for="(item, index) in zjTableArr" :key="index">
            <td width="10%">
              {{ index + 1 }}
            </td>
            <td width="15%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.orgName" v-if="item.orgName">
                {{ item.orgName }}
              </Poptip>
            </td>
            <td width="15%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.name" v-if="item.name">
                {{ item.name }}
              </Poptip>
            </td>
            <td width="15%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.relateName" v-if="item.relateName">
                {{ item.relateName }}
              </Poptip>
            </td>
            <!-- <td width="15%">
              <Poptip
                trigger="hover"
                transfer
                :word-wrap="true"
                :content="item.position"
                v-if="item.position && item.position!='null'"
              >
                {{item.position}}
              </Poptip>
            </td> -->
            <td width="15%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.state ? '离线' : '在线'">
                {{ item.state ? '离线' : '在线' }}
              </Poptip>
            </td>
            <td width="15%">
              <div class="td-option-wrap">
                <div style="width: 60px;">
                  <span class="viewDetail" @click="showDetailLayer(item.orgId, item, item.orgName)">查看</span>
                </div>
                <div style="width: auto;">
                  <Poptip trigger="hover" transfer :word-wrap="true" :content="'查看'">
                    <i class="iconfont video-btn" style="margin-left:30px" :class="{ 'active': item.hlsAddr }"
                      @click="showVideo(item)">&#xe7bc;</i>
                  </Poptip>
                </div>
              </div>
            </td>
          </tr>
        </table>
        <table v-if="tableTit == '传输装置'">
          <tr v-for="(item, index) in zjTableArr" :key="index">
            <td width="10%">
              {{ index + 1 }}
            </td>
            <td width="10%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.orgName" v-if="item.orgName">
                {{ item.orgName }}
              </Poptip>
            </td>
            <td width="15%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.gatewayTypeName"
                v-if="item.gatewayTypeName">
                {{ item.gatewayTypeName }}
              </Poptip>
            </td>
            <td width="15%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.model" v-if="item.model">
                {{ item.model }}
              </Poptip>
            </td>
            <td width="30%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.sid" v-if="item.sid">
                {{ item.sid }}
              </Poptip>
            </td>
            <td width="10%">
              <Poptip trigger="hover" transfer :word-wrap="true" :content="item.stateName" v-if="item.stateName">
                {{ item.stateName }}
              </Poptip>
            </td>
            <td width="10%">
              <div class="td-option-wrap">
                <div style="width: 25px;">
                  <Poptip trigger="hover" transfer :word-wrap="true" :content="'详情'">
                    <i class="iconfont" @click="showDetailLayer(item.orgId, item, item.orgName)">&#xe688;</i>
                  </Poptip>
                </div>
              </div>
            </td>
          </tr>
        </table>
        <p class="no-data" v-show="!zjTableArr.length">
          暂无数据
        </p>
      </div>
    </div>
    <Modal v-model="modalShow" :closable="true" width="800" :footer-hide="true" @on-visible-change="modalChangeg">
      <div style="width:700px;height:350px;margin:auto">
        <videoPlay :previewUrl="modalVideoSrc" :videoId="991" :channelNum="channelNum" :videoDeviceId="videoDeviceId" :videoSid="videoSid"
          v-if="modalShow" @hideClose="modalVideoSrc = ''" :height="350" :width="700" :showClose="false" />
      </div>
    </Modal>
  </div>
</template>
<script>
import newClose from "@/assets/img/newClose.png";
import videoPlay from "../videoPlay/videoPlay.vue";
import videojs from "video.js";
export default {
  name: "",
  data: () => ({
    deviceStatusArr: [],
    deviceStatus: "",
    departArr: [],
    departId: "",
    partTypeCode: "",
    newClose,
    industArr: [],
    industId: "",
    areaArr: [],
    areaId: "",
    getTableStatus: false,
    tableList: [],
    totalCount: "",
    currentPage: 1,
    hashValue: "",
    loginData: {},
    orgId: '',
    timeArr: [
      {
        text: "今日",
        index: 0,
      },
      {
        text: "本周",
        index: 1,
      },
      {
        text: "本月",
        index: 2,
      },
    ],
    timeIndex: 0,
    tableTit: "",
    zjTit: "",
    zjTableArr: [],
    partTypeArr: [],
    zjTotalCount: "",
    zjCurrentPage: 1,
    player: null,
    videoArr: [],
    modalShow: false,
    modalVideoSrc: "",
    videoDeviceId: "",
    channelNum: "",
    videoSid: "",
    botTableOrgId: "",
    xjOrgId: "",
  }),
  watch: {
    navName: {
      handler(newVal, oldVal) {
        this.tableTit = newVal;
        this.areaId = "";
        this.industId = "";
        this.deviceStatus = "";
        this.departId = "";
        this.timeIndex = 0;
        this.tableList = [];
        this.totalCount = "";
        this.currentPage = 1;

        this.zjTit = "";
        this.zjTableArr = [];
        this.zjTotalCount = "";
        this.zjCurrentPage = 1;
        // this.getTable();
      },
      // immediate: true,
      deep: true,
    },
  },
  components: {
    videoPlay,
  },
  created() {
    this.hashValue = localStorage.getItem("hashValue");
    this.loginData = JSON.parse(localStorage.getItem("loginData"));
    this.getAreaData();
    this.getIndustData();
    this.getDeviceData();
    this.getDepartData();
    // 标题， 根据标题请求数据
    this.tableTit = this.$store.state.showLayer.navIndex;
  },
  mounted() {
    this.getTable();
  },
  computed: {
    navName() {
      return this.$store.state.showLayer.navIndex;
    },
  },
  methods: {
    modalChangeg(status) {
      if (!status) {
        this.modalVideoSrc = "";
        this.$nextTick(() => {
          this.videoDispose();
        });
      }
    },
    initVideo(url) {
      if (this.player) {
        this.player.src(url);
        this.player.play();
        return;
      }
      this.player = videojs(
        "xfVideo",
        {
          src: url,
          autoplay: true,
          width: 768,
          height: 500,
        },
        function () {
          videojs.log("播放器已经准备好了!");
        }
      );
    },
    videoDispose(id) {
      if (this.player) {
        this.player.dispose();
        this.player = null;
        this.videoArr.pop();
      }
    },
    showVideo(activeItem) {
      //消防运行情况 操作列 视频
      if (!activeItem.hlsAddr) {
        return;
      }
      console.log(activeItem.hlsAddr);
      console.log("视频地址");

      this.modalShow = true;
      this.modalVideoSrc = activeItem.hlsAddr;
      this.videoDeviceId = activeItem.id;
      this.channelNum = activeItem.channelNum;
      this.videoSid = activeItem.num;
      // this.videoArr.push(1);
      // this.$nextTick(()=>{
      //     this.initVideo();
      // });
    },
    showDetailLayer(id, item, tit) {
      //显示详情弹窗
      this.$store.commit("baseInfoLayer", {
        detailStatus: true,
        baseInfoId: id,
        baseInfoItem: item,
        baseInfoTitle: tit,
      });
    },
    closeLayer() {
      this.$store.commit("showLayer", {
        status: false,
        type: "",
      });
    },
    zjClick(orgId, orgName) {
      this.zjTit = orgName;
      this.zjTableArr = [];
      this.zjTotalCount = "";
      this.zjCurrentPage = 1;
      this.getZjData(orgId);
    },
    formChange() {
      this.tableList = [],
        this.totalCount = "";
      this.currentPage = 1;
        this.zjTableArr = [];
        this.zjTotalCount = "";
        this.zjCurrentPage = 1;
        console.log('botTableOrgId:', this.botTableOrgId);
        // this.getZjData(this.botTableOrgId);
        this.getTable();
    },
    formChange1() {
      //获取下 table
      this.zjTableArr = [];
      this.zjTotalCount = "";
      this.zjCurrentPage = 1;
      this.getZjData(this.botTableOrgId);
    },
    tdGetZjData(orgId, orgName) {
      this.zjTit = orgName;
      this.zjTableArr = [];
      this.zjTotalCount = "";
      this.zjCurrentPage = 1;
      this.orgId = orgId
      this.getZjData(orgId);
      this.getPartData()
    },
    getAreaData() {
      let dataObj = {
        type: "get",
        // url: '/mcbw/areas/' + this.loginData.orgId,
        url: "/mcbw/departments/org/area",
        obj: {
          pageSize: 1000,
          currentPage: 1,
        },
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("区域数据");
        if (res.data.success && res.data.data.length) {
          this.areaArr = res.data.data;
        }
      });
    },
    getIndustData() {
      let dataObj = {
        type: "get",
        url: "/mcbw/dictionary_datas/industryCategory/data",
        obj: {},
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("行业数据");
        if (res.data.success && res.data.data.length) {
          this.industArr = res.data.data;
        }
      });
    },
    getDeviceData() {
      let dataObj = {
        type: "get",
        url: "/mcbw/dictionary_datas/partStateCode/data",
        obj: {
          pageSize: 1000,
          currentPage: 1,
        },
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("部件状态");
        if (res.data.success && res.data.data.length) {
          this.deviceStatusArr = res.data.data;
        }
      });
    },
    getPartData() {
      let dataObj2 = {
        type: "get",
        url: "/mcbw/device_part_stats/partType/data",
        obj: {
          pageSize: 1000,
          currentPage: 1,
          systemForms: '28',
          orgId: this.orgId
        },
      };
      this.$Axios(dataObj2).then((res) => {
        console.log(res);
        console.log("部件状态");
        if (res.data.success && res.data.data.length) {
          this.partTypeArr = res.data.data;
        }
      });
    },
    getDepartData() {
      let dataObj = {
        type: "get",
        url: "/mcbw/departments/owner",
        obj: {
          pageSize: 1000,
          currentPage: 1,
          name: "",
        },
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("全部单位");
        if (res.data.success && res.data.data.length) {
          this.departArr = res.data.data;
        }
      });
    },
    getTable() {
      // $('#rightBot').mCustomScrollbar('destroy');
        this.getTableStatus = false;
        let url = "/mcbw/dep_stats/depType/list";
        let obj = {};
        switch (this.tableTit) {
          case "消防主机":
            obj = {
              pageSize: 50,
              currentPage: this.currentPage,
              industryCategory: this.industId,
              areaId: this.areaId,
              orgId: this.departId,
              type: "fire_contr_host",
            };
            break;
          case "电气火灾监控":
            obj = {
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: "15",
              type: "systemForms",
              areaId: this.areaId,
              industryCategory: this.industId,
              orgId: this.departId,
            };
            break;
          case "消防水系统":
            obj = {
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: "2,4",
              type: "systemForms",
              areaId: this.areaId,
              industryCategory: this.industId,
              orgId: this.departId,
            };
            break;
          case "独立式探测器":
            obj = {
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: "28",
              type: "systemForms",
              areaId: this.areaId,
              industryCategory: this.industId,
              orgId: this.departId,
            };
            break;
          case "自动灭火系统":
            obj = {
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: "32",
              type: "systemForms",
              areaId: this.areaId,
              industryCategory: this.industId,
              orgId: this.departId,
            };
            break;
          case "智能空开":
            obj = {
              pageSize: 50,
              currentPage: this.currentPage,
              systemForms: "22",
              type: "systemForms",
              areaId: this.areaId,
              industryCategory: this.industId,
              orgId: this.departId,
            };
            break;
          case "巡检系统(NFC)":
            obj = {
              pageSize: 50,
              currentPage: this.currentPage,
              industryCategory: this.industId,
              areaId: this.areaId,
              orgId: this.departId,
              type: "npc",
            };
            break;
          case "视频监控":
            obj = {
              pageSize: 50,
              currentPage: this.currentPage,
              industryCategory: this.industId,
              areaId: this.areaId,
              orgId: this.departId,
              type: "camera",
            };
            break;
          case "传输装置":
            obj = {
              pageSize: 50,
              currentPage: this.currentPage,
              industryCategory: this.industId,
              areaId: this.areaId,
              orgId: this.departId,
              type: "transmission_device",
              gatewayTypes: "1,2",
            };
            break;
        }

        let dataObj = {
          type: "get",
          url: url,
          obj: obj,
        };
        this.$Axios(dataObj).then((res) => {
          console.log(res);
          console.log("表格详情");
          this.getTableStatus = true;
          if (res.data.success) {
            if (res.data.totalCount) {
              this.totalCount = res.data.totalCount;
            }
            if (!res.data.data.length) {
              return;
            }
            this.tableList = [...this.tableList, ...res.data.data];
            if (this.currentPage == 1) {
              //获取警情信息
              this.zjTit = this.tableList[0].orgName;
              this.orgId = this.tableList[0].orgId;
              
              this.getZjData(this.tableList[0].orgId);
              // this.getPartData(this.systemForms)
              this.getDeviceData();
            }
            let _this = this;
            this.$nextTick(() => {
              $JQ("#rightBot").mCustomScrollbar({
                callbacks: {
                  onTotalScroll: function () {
                    if (
                      _this.tableList.length == res.data.totalCount ||
                      res.data.data.length == 0
                    ) {
                      console.log("没有更多数据");
                      return;
                    } else {
                      console.log("加载更多");
                      _this.currentPage += 1;
                      _this.getTable();
                    }
                  },
                },
              });
            });
          }
        });
    },
    getZjData(orgId) {
      this.botTableOrgId = this.orgId;
      var orgId = this.orgId
      let url = "";
      let obj = {};
      switch (this.tableTit) {
        case "消防主机":
          url = "/mcbw/fire_control_hosts";
          obj = {
            pageSize: 50,
            currentPage: this.zjCurrentPage,
            orgId: orgId,
          };
          break;
        case "电气火灾监控":
          url = "/mcbw/device_parts";
          obj = {
            pageSize: 50,
            currentPage: this.zjCurrentPage,
            systemForms: "15",
            orgId: orgId,
            partStateCode: this.deviceStatus,
          };
          break;
        case "消防水系统":
          url = "/mcbw/device_parts";
          obj = {
            pageSize: 50,
            currentPage: this.zjCurrentPage,
            systemForms: "2,4",
            orgId: orgId,
            partStateCode: this.deviceStatus,
          };
          break;
        case "独立式探测器":
          url = "/mcbw/device_parts";
          obj = {
            pageSize: 50,
            currentPage: this.zjCurrentPage,
            systemForms: "28",
            orgId: orgId,
            partStateCode: this.deviceStatus,
            partTypeCode: this.partTypeCode
          };
          break;
        case "自动灭火系统":
          url = "/mcbw/device_parts";
          obj = {
            pageSize: 50,
            currentPage: this.zjCurrentPage,
            systemForms: "32",
            orgId: orgId,
            partStateCode: this.deviceStatus,
          };
          break;
        case "智能空开":
          url = "/mcbw/device_parts";
          obj = {
            pageSize: 50,
            currentPage: this.zjCurrentPage,
            systemForms: "22",
            orgId: orgId,
            partStateCode: this.deviceStatus,
          };
          break;
        case "巡检系统(NFC)":
          url = "/mcbw/patrol_cards";
          obj = {
            pageSize: 50,
            currentPage: this.zjCurrentPage,
            orgId: orgId,
          };
          //巡检系统，底部table没有返回orgId，需要记录当前点击的orgId
          this.xjOrgId = orgId;
          break;
        case "视频监控":
          url = "/mcbw/cameras";
          obj = {
            pageSize: 50,
            currentPage: this.zjCurrentPage,
            orgId: orgId,
          };
          break;
        case "传输装置":
          url = "/mcbw/transmission_devices";
          obj = {
            pageSize: 50,
            currentPage: this.zjCurrentPage,
            orgId: orgId,
            gatewayTypes: "1,2",
          };
          break;
      }

      let dataObj = {
        type: "get",
        url,
        obj,
      };
      console.log(dataObj);

      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log(this.tableTit + "底部table数据");
        if (res.data.success) {
          if (res.data.totalCount) {
            this.zjTotalCount = res.data.totalCount;
          }
          if (!res.data.data.length) {
            return;
          }
          this.zjTableArr = [...this.zjTableArr, ...res.data.data];
          let _this = this;
          this.$nextTick(() => {
            $JQ("#rightBot_zj").mCustomScrollbar({
              callbacks: {
                onTotalScroll: function () {
                  if (
                    _this.zjTableArr.length == res.data.totalCount ||
                    res.data.data.length == 0
                  ) {
                    console.log("没有更多数据");
                    return;
                  } else {
                    console.log("加载更多");
                    _this.zjCurrentPage += 1;
                    _this.getZjData(orgId);
                  }
                },
              },
            });
          });
        }
      });

    },
  },
};
</script>
<style lang="scss" scoped>
.layer-tem {
  position: absolute;
  left: 500px;
  bottom: 0;
  width: calc(100% - 1000px);
  padding: 30px 25px;
  background: rgba(6, 18, 44, 1) url("../../assets/img/maskBg.png") center center/101% 102% no-repeat;
  border-radius: 4px;
  z-index: 12;

  // 关闭按钮
  .close-btn {
    position: absolute;
    right: 0;
    top: 0;
    right: 15px;
    top: 15px;
    cursor: pointer;
  }

  .table-tit {
    font-size: 26px;
    font-weight: 600;
  }

  .select-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;

    .tit {
      min-width: 200px;
      max-width: 400px;
      margin-right: 20px;

      &.zj-tit {
        font-size: 18px;
        font-weight: 600;
      }
    }
  }

  .table-wrap {
    height: 200px;
    display: flex;
    flex-direction: column;

    .table-head {
      background: #0c2745;
      color: #7db4db;

      table th {
        height: 30px;
      }
    }

    .table-body {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      color: #e4eff5;

      /deep/ .mCSB_scrollTools {
        right: 0 !important;

        .mCSB_dragger {
          background: rgba(255, 255, 255, 0.3);
          border-radius: 8px;

          .mCSB_dragger_bar {
            width: 8px;
          }
        }

        .mCSB_draggerRail {
          background-color: transparent;
        }
      }

      table td {
        text-align: center;
        height: 30px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        i {
          cursor: pointer;
        }

        .td-option-wrap {
          display: flex;
          align-items: center;
          justify-content: center;

          i.video-btn {
            color: rgba(8, 244, 247, 0.3);

            &.active {
              color: rgba(8, 244, 247, 0.7);
            }
          }
        }
      }

      table tr:nth-child(2n) {
        background: #0c2745;
      }

      .no-data {
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ddd;
      }
    }

    table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
    }
  }
}

/deep/ .ivu-select-single .ivu-select-input {
  color: #00eef3;
}
</style>



// WEBPACK FOOTER //
// src/components/layer/midBot.vue